export default __webpack_public_path__ + "static/media/sun.c7441aab.svg";